import { ERentioFormField } from "../../components/components/Form";
import { getValue } from "../../redux/form/form.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { EField } from "./schema.forgotPassword.types";
export var getSchema = function (initialValues) {
    return function (defaultValues) {
        var _a;
        return ({
            required: [EField.PhoneOrEmail, EField.Captcha],
            properties: (_a = {},
                _a[EField.PhoneOrEmail] = {
                    default: getValue(EField.PhoneOrEmail, initialValues, defaultValues),
                },
                _a[EField.Captcha] = {
                    default: getValue(EField.Captcha, initialValues, defaultValues),
                },
                _a),
        });
    };
};
export var uiSchema = function () {
    var _a;
    return (_a = {
            "rentio:trackingKey": "forgot-password"
        },
        _a[EField.PhoneOrEmail] = {
            "ui:field": ERentioFormField.PhoneOrEmail,
            title: getLocalizedText("auth.phone_or_email.label"),
            placeholder: getLocalizedText("auth.phone_or_email.label"),
        },
        _a[EField.Captcha] = {
            "ui:field": ERentioFormField.Captcha,
            title: getLocalizedText("system.captcha"),
        },
        _a);
};
